import CONFIG from 'Config';
import { getCookie, isNil } from 'Utils';
// eslint-disable-next-line import/no-cycle
import { request } from 'Api';
import { IFormModelData } from './types';
import { BaseFormModel } from './BaseFormModel';
import { BaseHubSpotFormModelErrorHandler } from './BaseHubSpotFormModelErrorHandler';

const FIELD_MAP: Record<string, string> = {
  first_name: 'firstname',
  last_name: 'lastname',
};

type hubSpotField = { name: string, value: IFormModelData[keyof IFormModelData] };

// $submitted and all related methods are not implemented

export abstract class BaseHubSpotFormModel extends BaseFormModel<unknown> {
  formErrorHandler: BaseHubSpotFormModelErrorHandler;

  constructor() {
    super();

    this.formErrorHandler = new BaseHubSpotFormModelErrorHandler();
  }

  abstract get hubSpotFormId(): string;

  get sendUrl(): string {
    return `${CONFIG.urls.hubspotForm}/${CONFIG.hubspotPortalId}/${this.hubSpotFormId}`;
  }

  get hubSpotFormName() {
    return '';
  }

  _getHubSpotContext() {
    return {
      hutk: getCookie('hubspotutk'),
      pageUri: window.location.href,
      pageName: document.title,
    };
  }

  _getHubSpotFieldsData(): hubSpotField[] {
    const data = this._mapFields(this.fieldsData);
    const result: hubSpotField[] = [];
    // Clear for null or undefined fields
    Object.entries(data).forEach(([name, value]) => {
      if (!isNil(value)) result.push({ name, value });
    });
    return result;
  }

  _mapFields(data: IFormModelData): IFormModelData {
    const newData = { ...data };
    Object.entries(FIELD_MAP).forEach(([from, to]) => {
      if (newData[from]) {
        newData[to] = newData[from];
        delete newData[from];
      }
    });
    return newData;
  }

  /**
   * Send form data to CMS
   * Using during sending data to HubSpot
   * so to do not loss data when hubspot do not accept client email
   */
  sendFormToCMS() {
    // Do not send form data if not form name
    if (!this.hubSpotFormName) return Promise.resolve();

    // eslint-disable-next-line camelcase
    const { email, first_name, last_name, ...data } = this.fieldsData;
    const sendData = {
      form_name: this.hubSpotFormName,
      email,
      first_name,
      last_name,
      data,
    };
    return request(`${CONFIG.urls.cms}/form`, 'POST', sendData);
  }

  async beforeSend() {
    this.sendFormToCMS();
    return super.beforeSend();
  }

  getSendData() {
    return {
      context: this._getHubSpotContext(),
      fields: this._getHubSpotFieldsData(),
    };
  }
}
